<main class="flex-1 flex flex-col px-10 pt-6 mt-24">
  <header class="flex justify-between">
    <h1 id="my-courses-title" class="text-5xl font-bold text-lWhite mb-6">Meus cursos</h1>

    <l-user-courses-filter
      searchInputId="my-courses-search"
      searchInputName="myCoursesSearch"
      [categories]="categories"
      (filtersChange)="applyFilters($event)"
    />
  </header>

  <hr class="border-lPurple300 mb-4">

  <nav>
    <l-user-courses-pills
      [pills]="tabPills"
      [activeTab]="activeTab"
      (activeTabChange)="onTabChange($event)"
    />
  </nav>

  <section class="mt-6">
    @if (isLoadingCourses) {
      <div class="flex min-h-[35vh] items-center justify-center">
        <l-spinner />
      </div>
    } @else {
      <h2 id="my-courses-section-title" class="text-3xl font-semibold text-lWhite mb-6">
        @if (activeTab === tabFilterEnum.IN_PROGRESS) {
          Continue aprendendo
        } @else if (activeTab === tabFilterEnum.READY_TO_START) {
          Prontos para começar
        } @else if (activeTab === tabFilterEnum.COMPLETED) {
          Concluídos
        }
      </h2>

      @if (filteredCourses.length > 0) {
        <ng-template #courseCard let-course>
          <l-course-card [course]="course" />
        </ng-template>

        <article>
          <l-carousel [items]="filteredCourses" [itemTemplate]="courseCard" />
        </article>
      } @else {
        <article class="text-center py-12">
          <p class="text-lSecondary text-lg">Nenhum curso encontrado</p>
        </article>
      }
    }
  </section>
</main>